module.exports = __webpack_public_path__ + "day_in_the_life.3ced4b40.mp4";


//////////////////
// WEBPACK FOOTER
// ./client/components/day_in_the_life.mp4
// module id = 481
// module chunks = 0